import NTNavbar from "@/components/feature/NTNavbar";
import NTFooter from "@/components/feature/NTFooter";
import NTHero from "./components/NTHero";
import NTAboutSection from "./components/NTAboutSection";
import NTDiferenciais from "./components/NTDiferenciais";
import NTServicesSection from "./components/NTServicesSection";
import NTProductsSection from "./components/NTProductsSection";
import NTAutomationSection from "./components/NTAutomationSection";
import NTTestimonials from "./components/NTTestimonials";
import NTCtaSection from "./components/NTCtaSection";
import NTFinanciamentoSection from "./components/NTFinanciamentoSection";

export default function NewTechHomePage() {
  return (
    <div className="min-h-screen bg-white font-inter">
      <NTNavbar />
      <main className="pt-[88px]">
        <NTHero />
        <NTAboutSection />
        <NTDiferenciais />
        <NTServicesSection />
        <NTProductsSection />
        <NTCtaSection />
        <NTFinanciamentoSection />
        <NTAutomationSection />
        <NTTestimonials />
      </main>
      <NTFooter />
    </div>
  );
}
